import React from 'react';
import {DropdownButton,} from 'react-bootstrap';
import moment from 'moment';
import _ from 'lodash';
import { formatWorkDuration } from '../../../../util/dates';

import '../../Reports.scss';
import pagination from '../../../../util/pagination';
import RadioButton from '../../../../components/RadioButton/RadioButton';


class ReportTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getColumnName(dates) {
    return dates.type === 'quarter'
      ? `${moment.utc(dates.from).format(this.props.dateFormat)} - ${moment.utc(dates.to).format(this.props.dateFormat)}`
      : `${moment(dates.from).format(this.props.dateFormat)} - ${moment(dates.to).format(this.props.dateFormat)}`;
  }

  handleChange = e => {
    this.props.changePercentile(e.value);
  };

  renderPercentilesDropDown() {
    const { percentile } = this.props;
    const percentiles = [30, 50, 70, 85, 95, 98].map(p => {
      return (
        <li className='dropdown-item'>
          <RadioButton
            key={p}
            label={`${p}%`}
            id="percentile"
            name="percentile"
            value={p}
            checked={percentile == p}
            onChange={this.handleChange}
          />
        </li>
      );
    });
    return (
      <DropdownButton
        key="1"
        id="createdashboards-dropdown"
        className='form-control-dropdown'
        title={`${this.props.percentile}%`}
      >
        <ul>
          {percentiles}
        </ul>
      </DropdownButton>
    );
  }

  renderValue(value, positive = false, time = false) {
    if (value && value.value) {
      const displayValue = time
        ? formatWorkDuration(value.value, this.props.excludeWeekendOpts, 'd[d] h[h]')
        : value.value.toFixed(2);
      if (typeof value.comparison === 'undefined') {
        return <p>{displayValue}</p>;
      } else if (value.comparison > 0) {
        return (
          <p>
            <span className={`value ${value.active ? (!positive ? 'positive' : 'negative') : 'neutral'}`}>
              {value.comparison.toFixed()}%
              <span className={value.active ? (!positive ? 'positive' : 'negative') : 'neutral'}>
                {value.active ? 
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M6.41681 3.39763L3.73348 6.06638L2.91681 5.24971L7.00014 1.16638L11.0835 5.24971L10.2668 6.08096L7.58348 3.39763V7.58305H6.41681V3.39763ZM6.41681 10.4997V8.74971H7.58348V10.4997H6.41681ZM6.41681 12.833V11.6664H7.58348V12.833H6.41681Z"/>
                  </svg> : '='}
              </span>
            </span>
            {displayValue} 
          </p>
        );
      } else {
        return (
          <p>
            <span className={`value ${value.active ? (positive ? 'positive' : 'negative') : 'neutral'}`}>
              {value.comparison.toFixed()}%
              <span className={value.active ? (positive ? 'positive' : 'negative') : 'neutral'}>
                {value.active ? 
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <path d="M6.99999 12.8333L2.91666 8.75001L3.73332 7.91876L6.41666 10.6021V6.41667H7.58332V10.6021L10.2667 7.93334L11.0833 8.75001L6.99999 12.8333ZM6.41666 5.25001V3.50001H7.58332V5.25001H6.41666ZM6.41666 2.33334V1.16667H7.58332V2.33334H6.41666Z"/>
                  </svg> : '='}
              </span>
            </span>
            {displayValue}
          </p>
        );
      }
    } else {
      return (
        <p>
          <span>-</span>
        </p>
      );
    }
  }

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 10, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage ? 'active' : ''} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  render() {
    return (
      <React.Fragment>
        <div className='table-content table-content-no-resp'>
          <div className='table-filter'>
            <h5>{this.props.columnHeader}</h5>
            <React.Fragment>{this.props.percentile && this.renderPercentilesDropDown()}</React.Fragment>
          </div>

          {!this.props.loading && (
            <div className='table-scroll'>
              <table className='table'>
                <thead>
                  <tr>
                    <th></th>
                    {this.props.dates.map((d, i) => (
                      <th className='aling-right'  key={i}>
                        <p>{this.getColumnName(d)}</p>
                      </th>
                    ))}
                  </tr>
                </thead>
                
                <tbody>
                  {_.map(this.props.data, (r, i) => {
                    return (
                      <React.Fragment key={i}>
                        {
                          r.map((g, i) => {
                            return (
                              <tr key={i}>
                                <td>
                                  <p>{g.name}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][0], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][1], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][2], this.props.positive, this.props.time)}</p>
                                </td>
                                <td className='aling-right'>
                                  <p>{this.renderValue(g[this.props.fieldName][3], this.props.positive, this.props.time)}</p>
                                </td>
                              </tr>
                            );
                          })
                        }
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          {this.props.total > 0 && this.renderPagination()}
        </div>

        {this.props.loading && (
          <div className='table-loading loader-delay'>
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default ReportTable;
